module.exports = __webpack_public_path__ + "img/man--580.967d598.jpg";